<template>
	<div>
		<div class="create-company-container w-100 ">
			<div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress && sales_forecast_details == null">
				<half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
			</div>
			<div v-else-if="!ajaxCallInProgress && sales_forecast_details">
				<div class="main-div">
					<div class="create-company-header d-flex align-items-center justify-content-between">
						<span class="fs-14  pl-10 text-white header-text">Set Sales Forecast Target</span>
						<span class="description-text-header-right d-flex align-items-center">
							<span class="fs-14  pl-3 text-white ml-3 header-spacing">
								<span>{{ territory || '' }}</span>
								<span v-if="territory">,</span>
								<span>{{ country }}</span>
							</span>

							<i class="icon-map-marker text-white header-spacing" />
							<span class="ml-2" :class="{'pointer':loggedInUser.user_role == 'sales_manager'}" @click="editLocation()" v-if="loggedInUser.user_role == 'sales_manager'">
								<i class="icon-pencil text-white edit-icon header-spacing"></i>
							</span>
						</span>
					</div>

				</div>
				<div class="align-center">
					<div class="row row-btn">
						<div>
							<multiselect :disabled="loggedInUser.user_role != 'sales_manager'" :class="{'no-arrow':loggedInUser.user_role != 'sales_manager'}"
								class="digi-multiselect approval-manager"
								placeholder="Product" @close="getSalesInfo()"
								label="name" open-direction="bottom"
								v-model="product" @open="resetData('name')"
								:options="products_options" track-by="name"
								:multiple="false" :searchable="true" :internal-search="true"
								:clear-on-select="false" :close-on-select="true" :options-limit="3000"
								:max-height="200" :show-no-results="true" :hide-selected="false"
								:blockKeys="['Delete']" :limit="1" :limit-text="limitProduct" :loading="products_loading" @search-change="searchProuctName"
							>
								<template slot="option" slot-scope="props" class="d-flex">
									{{ props.option.name }}
								</template>
								<template slot="afterList">
									<div v-observe-visibility="reachedEndOfProductName" />
								</template>
								<template slot="noOptions">
									<div class="text-secondary text-center fw-600">Products Not Found</div>
								</template>
								<template slot="noResult">
									<div class="text-secondary text-center fw-600">No Results Found</div>
								</template>
							</multiselect>
							<!-- <multiselect :disabled="loggedInUser.user_role != 'sales_manager'" :class="{'no-arrow':loggedInUser.user_role != 'sales_manager'}" @close="getSalesInfo()" @search-change="searchProducts" :loading="products_loading" class="digi-multiselect approval-manager" label="name" placeholder="Product" name="product1" v-model="product" :options="products_options" >
								<template slot="afterList">
									<div v-observe-visibility="reachedEndOfProducts" />
								</template>
							</multiselect> -->
						</div>
					</div>
					<div class="main-div nav-padding">
						<div class="create-company-header d-flex align-items-center justify-content-between">
							<span class="fs-14 pl-6 text-white header-text">{{sales_forecast_details.name}}</span>
						</div>
					</div>
					<div class="row pl-10" style="padding-right: 15px;">
						<div class="col-lg-5 col-md-6 col-sm-12">
							<form class="form-horizontal">
								<div class="form-inline">
									<span class="col-lg-3 col-sm-3 fs-14 title-header mr-20 whiteSpace">1. Target Amount</span>
									<div class="col-lg-2 col-sm-2 col-xs-2 ml-1 mt-0">
										<input type="text" readonly value="$" class="inputFieldNew text-center mt-1">
									</div>
									<div class="col-xs-3 col-lg-4 ml-0 pl-0 position-relative">
										<input type="text" :readonly="loggedInUser.user_role != 'sales_manager'" v-on:keypress="isNumber($event)" maxlength="8" pattern= "[0-9]+" @input="resetData()" v-model.number="target_amount" class="inputFieldNew mt-1" placeholder="Enter Amount" name="amount" >
										<span  class="dot position-absolute float-right">{{target_remaining_amount}}</span>
									</div>
									<span class="pointer ml-3" style="color:#008a63;">{{formatPrice(target_amount)}}</span>
								</div>
								<div class="form-inline mt-6">
									<label class="fs-14 title-header ml-3">2. Assign to</label>
								</div>
								<div class="container space_between mt-4">
									<div v-if="assigned.length == 0">
										Please <a class="text-secondary fw-600 fs-14 pointer" @click="addPerson()">Click</a> here to Add <b>Assign To</b>
									</div>
									<div v-else class="form-group row" v-for="(list,index) in assigned" :key="index">
										<label class="col-sm-3 col-form-label label-title pl-0 mt-2" @click="getLeadInfo(list)">{{list.assigned_to_person}}</label>
										<div class="col-sm-6 col-lg-5 pr-2 position-relative" style="padding-left: 18px;">
											<input  min="0" pattern= "[0-9]+" @input="checkTargetAmount(list)" maxlength="20" :readonly="target_amount == null || target_amount == ''" class="form-control inputFieldNew" style="height: 40px !important;" v-model.number="list.assigned_amount" placeholder="Enter Amount" name="amount">
											<span class="dot-assign position-absolute float-right">{{(list.remaining_assigned_amount)}}</span>
										</div>
										<span class="pointer mt-2" v-if="list.delete" @click="deletePerson(index)">
											<i class="icon icon-close icon-bg text-white bg-red"></i>
										</span>
										<span class="pointer ml-2 mt-2" :class="{'pointer-events':total_assigned_amount == target_amount}" v-if="index == (assigned.length - 1)" @click="addPerson()">
											<i class="icon icon-plus icon-bg text-white"></i>
										</span>
										<span class="ml-2 mt-3 text-danger fs-13" v-if="index == (assigned.length - 1)">{{formatPrice(remaining_amount)}}</span>
									</div>
								</div>
							</form>
						</div>
						<div class="col-lg-7 col-md-6 col-sm-12">
							<div class="second-tableCol">
								<div class="d-flex flex-wrap justify-content-between align-items-center table-spacing pl-2 pr-2">
									<div class="d-flex align-items-center">
										<div style="overflow-wrap: break-word;width: 275px;" v-if="leadData">
											<span style="color: #0475f3;font-weight: 600;" class="fs-13 text-capitalize">{{leadDataName + ' ' + '-'}} Previous Years Sales info</span>
										</div>
										<div style="overflow-wrap: break-word;width: 275px;" v-else>
											<span style="color: #0475f3;font-weight: 600;" class="fs-13 text-capitalize">{{product.name + ' ' + '-'}} Previous Years Sales info</span>
										</div>
										<multiselect @close="getSalesInfo()" v-if="sales_forecast_details.forecast_period != ''" placeholder="" class="diginew-multiselect year-width new-align-multi no-default-icon down-arrow ml-2" style="width:27%;" :options="years" v-model="year" :multiple="false" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="true">
										</multiselect>
									</div>
									<div class="d-flex align-items-center">
										<div class="d-flex search-box">
											<i class="icon icon-magnify icondefault search-icon"></i>
											<input class="w-100 placeholder-text search-text" type="text" v-on:keypress="isNumber($event)" v-model="search_key" v-debounce:500ms="getSalesInfo" debounce-events="input" placeholder="Search by Fiscal year">
										</div>
										<button class="btn btn-new-primary btn-wide filter-btn ml-1" @click="showFilters()" style="width: 88px !important;padding-left: 10px !important;">
											<img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px;">
											Filter
										</button>
									</div>
								</div>
								<!-- Table Section -->
								<table class="team-target-table w-100 table-responsive">
									<thead>
										<tr>
											<th class="w-1 whiteSpace fw-500">{{ sales_forecast_details.forecast_period == '' ? 'Fiscal Year' : sales_forecast_details.forecast_period == 'month' || sales_forecast_details.forecast_period == 'date' ? 'Month' : sales_forecast_details.forecast_period == 'half_yearly' ? 'Half-Yearly' : sales_forecast_details.forecast_period == 'quarterly' ? 'Quarter' : 'Year'}}</th>
											<th class="whiteSpace fw-500" v-if="sales_forecast_details.forecast_period == 'half-yearly'">Half-Yearly</th>
											<th class="whiteSpace fw-500">Target Amount<br>($)</th>
											<th class="whiteSpace fw-500">Achieved Amount<br>($)</th>
											<th class="whiteSpace fw-500">Pipeline Amount<br>($)</th>
											<th class="whiteSpace fw-500">Target Incr/<br>Sort by (%)</th>
										</tr>
									</thead>
									<tbody>
										<tr class="w-100" v-if="historical_data_loading && !sales_info.length">
											<td colspan="6">
												<div class="d-flex align-items-center justify-content-center w-100" v-if="historical_data_loading">
													<half-circle-spinner :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;" />
												</div>
											</td>
										</tr>
										<tr v-if="!historical_data_loading && sales_info.length == 0" class="text-center font-weight-bold">
											<td colspan="8" class="font-weight-bold">No Data Found</td>
										</tr>
										<tr v-else v-for="(info,index) in sales_info" :key="index">
											<td v-if="sales_forecast_details.forecast_period == 'half_yearly'">{{info.half_year}}</td>
											<td v-if="sales_forecast_details.forecast_period == 'quarterly'">{{info.quarter}}</td>
											<td v-if="sales_forecast_details.forecast_period == 'month'">{{info.month}}</td>
											<td v-if="sales_forecast_details.forecast_period == ''" class="whiteSpace">{{info.fiscal_year}}</td>
											<td>{{info.target}}</td>
											<td style="color:#038b64;">{{info.achieved_amount}}</td>
											<td style="color:#e69d58">{{info.pipeline_amount}}</td>
											<td>{{info.target}}</td>
										</tr>
									</tbody>
								</table>
								<div class="d-flex justify-content-end align-items-center bg-white py-2 px-4 target-pagination">
									<button @click="previousPage()" :disabled="skip == 0" class="pagination-list mt-1 ml-2 pointer">
										<el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
											<i class="icon icon-chevron-left"></i>
										</el-tooltip>
									</button>
									<span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} -
										{{total>skip+limit?skip+limit:total}} of {{total}}</span>
									<button @click="nextPage()" :disabled="skip_temp >= total"
										class="pagination-list mt-1 mr-2 pointer">
										<el-tooltip class="item" effect="dark" content="Next Page" placement="top">
											<i class="icon icon-chevron-right"></i>
										</el-tooltip>
									</button>
								</div>
							</div>
						</div>
					</div>
					<div v-if="disableButtonAndDisplayLoader == false" class="d-flex flex-wrap align-items-center justify-content-center mr-6 mt-8 pb-4">
						<button class="btn new-cancel-button" @click="cancelSetTarget()">Cancel</button>
						<button class="btn new-save-button ml-5" @click="saveSalesTarget()" :disabled="fields_not_changed">Save</button>
					</div>
					<div v-else class="d-flex flex-wrap align-items-center justify-content-center mr-6 mt-8 pb-4">
						<button class="btn btn-new-cancel" style="border: solid 1px transparent;" disabled>Cancel</button>
						<button class="btn btn-new-save btn-new-secondary ml-5" style="border: solid 1px transparent;position: relative;" disabled>Save
							<hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
						</button>
					</div>
				</div>
			</div>
		</div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
		<add-person :assigned="assigned_ids" v-if="show_employees" modal_name="add-employees" @hidePerson="hidePerson" @savePerson="savePerson"></add-person>
		<div v-show="display_filters" class="scm-filters fadeInDown sales-filtersdata" :class="{'fadeInUp':hide_filters == true}">
            <historical-filter @UpdateByFilter="UpdateByFilter" @hideFilters="hideFilters"></historical-filter>
        </div>
		<div v-show="edit_location_modal" class="scm-filters fadeInDown viewdeal-filters">
			<edit-location @closeCountry="closeCountry" @updateTerritory="updateTerritory" @updateCountry="updateCountry" :sales_forecast_details="sales_forecast_details"></edit-location>
        </div>
		<delete-person @hideDelete="hideDelete" @deleteLead="deleteLead" :selected_lead="selected_lead" v-if="show_delete" modal_name="show-delete"></delete-person>
	</div>
</template>

<script>
	import salesforecast from "../mixins/salesforecast";
	const AddPerson = () => import("./AddPerson.vue");
	const DeletePerson = () => import("./DeletePerson.vue");
	import { EventBus } from '../eventBus/nav-bar-event';
	import { HalfCircleSpinner } from "epic-spinners";
    import { SweetModal } from 'sweet-modal-vue';
    import deals from "../mixins/deals";
    import settings from "../mixins/settings";
	import HistoricalFilter from "./HistoricalFilter";
	import EditLocation from "./EditLocation"
	import { HollowDotsSpinner } from "epic-spinners";
	import { debounce } from 'lodash'
	import productsList from "../mixins/productList"
	export default {
		data() {
			return {
				stringified_response: "",
				disableButtonAndDisplayLoader: false,
                success_msg: 'Target Assigned Succesfully',
                warning_msg: '',
				erp_unit: [],
				department: [],
				//products lazy loading
                products_count: 0,
                products_loading:false,
                products_scrollable :false,
                products_visible: false,
                product: null,
                temp_products: [],
                products_options: [],
				cash_value: [],
				set_target: false,
				view_sale: false,
				show_lists: false,
				sales_forecast_details: null,
				ajaxCallInProgress: false,
				show_employees: false,
				assigned: [],
				target_amount: null,
				pageLimit: [],
				sales_info: [],
				warning_msg: '',
				success_msg: '',
				skip: 0,
				limit: 10,
				count: 0,
				start: 0,
				search_key: '',
				end: 0,
				total: 0,
				showTerritory:false,
				skip_temp: 0,
				temp_total: 0,
				ajax_call_in_progress: false,
				historical_data_loading: false,
				forecast_period: [ 'month', 'quarterly', 'half_yearly' ],
				product_id: null,
				year: '2022',
				years: ['2022','2023','2024','2025','2026'],
				hide_filters: false,
				display_filters: false,
				filters:{
					target_amount: "",
					achieved_amount: "",
					pipeline_amount: "",
					fiscal_year: []
				},
				assigned_ids: [],
				total_assigned_amount: 0,
				//territories lazy loading
                territory: "",
				edit_location_modal: false,
				country: "",
				show_delete: false,
				selected_lead: null,
				selected_index: null,
				leadData:false,
				leadDataName: '',
				territoryId:'',
				selected_field: '',
			}
		},
		mixins: [salesforecast,deals,settings, productsList],
		components:{
			AddPerson,
			SweetModal,
			HalfCircleSpinner,
			HistoricalFilter,
			EditLocation,
			DeletePerson,
			HollowDotsSpinner,
		},
		methods: {
			limitProduct(count) {
				return `+ ${count} more`
			},
			resetData(type){
				this.selected_field = type
				this.products_options = [];
				this.products_count = 0;
			},
			async deleteLead(){
				this.show_delete = false
				let params = {
					assigned_to_id: this.selected_lead.assigned_to_id,
            		sales_forecast_id: this.sales_forecast_details.id
				}
				let response = await this.deleteTeamLead(params)
				this.success_msg = response.message
				this.$refs.success_modal.open();
				setTimeout(() => {
					this.$refs.success_modal.close();
					this.assigned.splice(this.selected_index,1);
					this.assigned_ids = this.assigned.map(x => {return x.assigned_to_id})
					if(this.assigned.length){
						this.total_assigned_amount = this.assigned.reduce((total, x) => total += parseFloat(x.assigned_amount), 0)
					}
					else{
						this.total_assigned_amount = 0
					}
				}, 3000);

			},
			hideDelete(){
				this.show_delete = false
			},
			resetData(){
				this.assigned.forEach(x => {
					x.assigned_amount = 0
				})
				this.total_assigned_amount = this.assigned.reduce((total, x) => total += parseFloat(x.assigned_amount), 0)
			},
			isNumber: function(evt, index) {
				evt = evt ? evt : window.event
				var charCode = evt.which ? evt.which : evt.keyCode
				if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
					evt.preventDefault()
				} else {
					return true
				}
			},
			closeCountry(){
				this.edit_location_modal = false
			},
			updateCountry(value){
				this.country = value
				this.edit_location_modal = false
			},
			updateTerritory(value){
				this.territory = value.name
				this.territoryId = value.id
				this.edit_location_modal = false
			},
			formatPrice(value) {
                let val = (value / 1).toFixed(2).replace(",", ".");
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
			showFilters(){
				if(this.display_filters) {
					this.hide_filters = true
					setTimeout(() => {
						this.display_filters = false
						this.hide_filters = false
					}, 500);
				}
				else{
					this.display_filters = true
				}
        	},
			hideFilters() {
				this.hide_filters = true
				setTimeout(() => {
					this.display_filters = false
					this.hide_filters = false
				}, 500);
			},
			showTerritoryList() {
				this.showTerritory = true
			},
			deletePerson(index){
				if(this.assigned[index].hasOwnProperty('id')){
					this.selected_index = index
					this.selected_lead = this.assigned[index]
					this.show_delete = true
					setTimeout(() => {
						this.$modal.show("show-delete")
					}, 500);
				}
				else{
					this.assigned.splice(index,1);
					this.assigned_ids = this.assigned.map(x => {return x.assigned_to_id})
					if(this.assigned.length){
						this.total_assigned_amount = this.assigned.reduce((total, x) => total += parseFloat(x.assigned_amount), 0)
					}
					else{
						this.total_assigned_amount = 0
					}
				}
			},
			hidePerson(){
				this.show_employees = false
			},
			savePerson(value){
				this.show_employees = false
				this.assigned.push({
					assigned_to_person: value.full_name,
					assigned_to_id: value.user_id,
					assigned_amount: value.assigned_amount || 0,
					remaining_assigned_amount: this.target_amount.toString().length,
					delete: true
				})
				this.assigned_ids = this.assigned.map(x => {return x.assigned_to_id})
			},
			addPerson(){
				if(this.assigned.length){
					this.assigned_ids = this.assigned.map(x => {return x.assigned_to_id})
				}
				this.show_employees = true
				setTimeout(() => {
					this.$modal.show("add-employees")
				}, 500);

			},
			cancelSetTarget() {
				this.set_target = false
				this.show_lists = true
				EventBus.$emit("target", this.set_target)
				EventBus.$emit("list", this.show_lists)
				this.$router.push("/salesForeCast/salesCast/list")
			},
			async saveSalesTarget(){
				this.disableButtonAndDisplayLoader = true;
				let assigned_amount = false
				this.create_sales_target.territory_id= this.territoryId
				this.assigned.forEach(x => {
					if(x.assigned_amount == ''){
						assigned_amount = true
					}
					delete x['remaining_assigned_amount']
				})
				if(this.assigned.length && assigned_amount == false && this.target_amount){
					let response = await this.editSalesForeCast(this.$route.params.id,this.create_sales_target)
					this.success_msg = response.message
					this.$refs.success_modal.open();
                    setTimeout(() => {
						this.disableButtonAndDisplayLoader = false;
                        this.$refs.success_modal.close();
                        this.$router.push("/salesForeCast/view_sales_forecast/"+this.$route.params.id)
                    }, 3000);
				}
				else{
					this.warning_msg = this.assigned.length == 0  ? "Please Add Assgined To" : assigned_amount ? "Please Enter Assigned Amount" : "Target Amount is Required"
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
						this.disableButtonAndDisplayLoader = false;
                        this.$refs.warning_modal.close();
                    }, 3000);
				}
			},
			checkTargetAmount(list){
				list.remaining_assigned_amount = this.target_amount.toString().length - list.assigned_amount.toString().length
				if(list.remaining_assigned_amount == this.target_amount.toString().length){
					list.assigned_amount = 0
				}
				this.assigned.forEach(x => {
					if(isNaN(x.assigned_amount)){
						x.assigned_amount = 0
					}
				})
				this.total_assigned_amount = this.assigned.reduce((total, x) => total += parseFloat(x.assigned_amount), 0)
				if(this.total_assigned_amount > this.target_amount){
					this.warning_msg = "Sum of Assigned Amount must not be greater than Target Amount"
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
						if(this.assigned.length == 1){
							list.assigned_amount = this.target_amount
							list.remaining_assigned_amount = this.target_amount.toString().length - list.assigned_amount.toString().length
							this.total_assigned_amount = this.assigned.reduce((total, x) => total += parseFloat(x.assigned_amount), 0)
						}
						else{
							list.assigned_amount = 0
							list.remaining_assigned_amount = this.target_amount.toString().length - list.assigned_amount.toString().length
							this.total_assigned_amount = this.assigned.reduce((total, x) => total += parseFloat(x.assigned_amount), 0)
						}
                        this.$refs.warning_modal.close();
                    }, 2000);
				}
			},
			async searchProuctNameDebouncer(search){
				this.products_loading = true
				this.products_count = 0
				let params = {
					skip: this.skip,
					limit: 10,
					search_key: search,
					sort_key: "name",
					sort_value: 1,
					category_ids:[],
					sub_category_ids:[],
					product_type_ids:[],
					product_ids:[],
					brand_ids:[],
					outlet_ids:[],
					status:[],  
					visibility:"Manufacturing"
				}
				let response = await this.ProductsList(params)
				this.products_options = response.response.result
				
				this.products_count = this.products_options.length
				this.products_loading = false
			},
			async reachedEndOfProductName(reached){
				if(reached){
					if(this.products_scrollable == false){
						this.products_loading = true
						let response = await this.ProductsList({
							skip: this.products_count,
							limit: 10,
							search_key: '',
							sort_key: "name",
							sort_value: 1,
							category_ids:[],
							sub_category_ids:[],
							product_type_ids:[],
							product_ids:[],
							brand_ids:[],
							outlet_ids:[],
							status:[],  
							visibility:"Manufacturing"
						} )
						let temp_products_options = response.response.result.length;
						if(response.response.filter_data.skip == this.products_count){
							if(temp_products_options > 0){
								let tempfiles = response.response.result
								// tempfiles.forEach(el => {
								// 	if(el[this.selected_field] != '' && el.hasOwnProperty(this.selected_field)){
								// 		this.products_options.push(el)
								// 	}
								// })
								// let uniqueArray = this.products_options.filter((value, index_dd) => {
								// 	const _value = value[this.selected_field];
								// 	return index_dd === this.products_options.findIndex(obj => {
								// 		return obj[this.selected_field] === _value;
								// 	});
								// });
								this.products_options = tempfiles
								this.products_count += response.response.result.length;
								this.products_loading = false
							} else {
								this.products_scrollable = true
								this.products_loading = false
							}
							this.products_scrollable = false
						}
					}
				}
			},
			async loadSalesForecastDetails() {
				this.ajaxCallInProgress = true
				let response = await this.getSalesForecastDetails(this.$route.params.id)
				this.sales_forecast_details = response.response
				this.target_amount = this.sales_forecast_details.target
				this.territoryId = this.sales_forecast_details.territory_id
				if(this.sales_forecast_details.assignation.length){
					this.sales_forecast_details.assignation.forEach(x => {
						this.assigned.push({
							assigned_to_person: x.assigned_to_person,
							assigned_to_id: x.assigned_to_id,
							assigned_amount: x.assigned_amount,
							remaining_assigned_amount: this.target_amount.toString().length - x.assigned_amount.toString().length,
							id: x.id,
							delete: x.delete
						})
					})
					this.total_assigned_amount = this.assigned.reduce((total, x) => total += parseFloat(x.assigned_amount), 0)
				}
				this.product = {
					id: this.sales_forecast_details.id,
					name: this.sales_forecast_details.name
				}
				this.country = this.sales_forecast_details.country
				this.territory = this.sales_forecast_details.territory
				this.ajaxCallInProgress = false
				this.getSalesInfo();
				return this.stringified_response = JSON.stringify(this.create_sales_target)
			},
			//products lazy loading
            async searchProductsDebounce(search_key) {
                this.products_loading = true
                try {
                    let params = {
                        skip: 0,
                        limit: 10,
                        search_key: search_key,
                        sort_value: 1,
                        sort_key: "name"
                    };
                    let response = await this.getProductsList(params)
                    this.products_options = response.response;
                    this.products_count = response.response.length;
                    this.products_loading = false
                }
                catch(error) {
                }
            },
            async reachedEndOfProducts(reached) {
                this.products_visible = reached
                if (reached) {
                    if (this.products_scrollable == false) {
                        this.products_loading = true
                        let response = await this.getProductsList({
                            skip: this.products_count,
                            limit: 10,
                            search_key: this.search_key,
                            sort_value: 1,
                            sort_key: "name"
                        })
                        this.temp_products = response.response.length;
                        if (response.skip == this.products_count) {
                            if (this.temp_products > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.products_options.push(el);
                                });
                                this.products_options = this.products_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.products_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.products_count += response.response.length;
                                this.products_loading = false
                            } else {
                                this.products_scrollable = true
                                this.products_loading = false
                            }
                        }
                        this.products_loading = false
                    }
                }
            },
			async getSalesInfo() {
				this.sales_info = [];
				this.historical_data_loading = true;
				try {
					let params = {
						skip: this.skip,
						limit: this.limit,
						search_key: this.search_key,
						product: this.product._id ? this.product._id  : this.product.id,
						product_name: this.product.name,
						forecast_period: this.sales_forecast_details.forecast_period ? this.sales_forecast_details.forecast_period : 'fiscal_year',
						filter_json: this.filters
					}
					if(this.sales_forecast_details.forecast_period == ''){
						params['fiscal_year'] = "2022-2023"
					}
					else{
						params['year'] = this.year
					}
					let response = await this.salesForeCastSalesInfo(params);

					this.sales_info = response.response;
					this.total = response.count;
					this.historical_data_loading = false;
				}
				catch(error) {
					this.historical_data_loading = false;
					this.warning_msg = error
					this.$refs.warning_modal.open();
					setTimeout(() => {
						this.$refs.warning_modal.close();
					}, 3000);
				}
        	},
			async getLeadInfo(list) {
				this.leadDataName = list.assigned_to_person
				this.sales_info = [];
				this.historical_data_loading = true;
				try {
					let params = {
						skip: this.skip,
						limit: this.limit,
						search_key: this.search_key,
						product: this.product.id,
						product_name: this.product.name,
						user_id:list.assigned_to_id,
						forecast_period: this.sales_forecast_details.forecast_period ? this.sales_forecast_details.forecast_period : 'fiscal_year',
						filter_json: this.filters
					}
					if(this.sales_forecast_details.forecast_period == ''){
						params['fiscal_year'] = "2022-2023"
					}
					else{
						params['year'] = this.year
					}
					let response = await this.salesForeCastLeadsInfo(params);

					this.sales_info = response.response;
					this.total = response.count;
					this.leadData = true

					this.historical_data_loading = false;
				}
				catch(error) {
					this.historical_data_loading = false;
					this.warning_msg = error
					this.$refs.warning_modal.open();
					setTimeout(() => {
						this.$refs.warning_modal.close();
					}, 3000);
				}
        	},
			previousPage() {
				this.temp_total = 0
				this.skip_temp = 0
				if (this.skip == 0) {
					return;
				}
				this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
				this.getSalesInfo();
				this.check_all = false;
			},
			nextPage() {
				this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
				if (this.skip_temp >= this.total) {
					return;
				}
				this.skip = this.skip_temp;
				this.check_all = false;
				this.getSalesInfo();
			},
			UpdateByFilter(params){
				this.skip = 0
				this.limit = 10
				this.filters = {
					target_amount: params.value.target_amount,
					achieved_amount: params.value.achieved_amount,
					pipeline_amount: params.value.pipeline_amount,
					fiscal_year: params.value.fiscal_year
				}
				this.getSalesInfo()
			},
			editLocation(){
				this.edit_location_modal = !this.edit_location_modal
			}
		},
		computed:{
			searchProuctName(){
				return debounce(this.searchProuctNameDebouncer, 500)
			},
			create_sales_target(){
				let targetValue = parseFloat(this.target_amount)
				this.assigned.forEach(x => {
				x.assigned_amount = parseFloat(x.assigned_amount)
				})
				return{
					target: targetValue,
					// product_id: this.product._id ? this.product._id  : this.product.id,
					product_name: this.product.name,
					country: this.country,
					assignation: this.assigned
				}
			},
			target_remaining_amount(){
				if(this.target_amount == null){
					this.target_amount = 0
				}
				return  8 - this.target_amount.toString().length
			},
			getSkipCount(){
				if (this.total == 0) {
					return 0
				} else {
					let skip_count = this.skip > this.total ? this.total : this.skip + 1;
					return skip_count;
				}
			},
			remaining_amount(){
				return this.target_amount - this.total_assigned_amount
				this.$forceUpdate()
			},
			loggedInUser() {
				return this.$store.state.loggedInUser;
			},
			fields_not_changed(){
                return this.stringified_response == JSON.stringify(this.create_sales_target)
            }
		},
		mounted(){
			this.loadSalesForecastDetails()
			for (let i = 1; i <= 50; i++) {
            	this.pageLimit.push(i);
        	}
		},
		created(){
			this.searchProducts = debounce(this.searchProductsDebounce, 500)
		},
	}
</script>

<style scoped>
	.main-div {
		background: #fff;
		border-top-right-radius: 10px;
		border-top-left-radius: 10px;
		border-bottom-right-radius: 10px;
		border-bottom-left-radius: 10px;
		padding-bottom: 10px;
	}

	.create-company-container {
		background-color: #fff;
		padding: 30px 0 0px 0;
		border-radius: 6px;
	}

	.create-company-header {
		padding: 6px 15px;
		background-color: #00448b;
	}

	.input-label {
		font-weight: 600;
		line-height: 1.5;
		letter-spacing: 0.39px;
		text-align: center;
		color: #005dae;
		padding: 0 0 6px 10px;
		font-size: 14px;
	}

	.description-text-header-right {
		font-size: 24px;
		margin-left: auto;
		padding-left: 12px;
		color: #005dae;
		font-weight: 500;
	}

	.header-spacing {
		padding-right: 10px;
	}

	.edit-icon {
		font-size: 24px;
	}

	.header-text {
		font-weight: 500;
	}

	.nav-padding {
		margin: 15px;
	}

	.inputFieldNew {
		font-size: 14px !important;
		display: block;
		/* width: 50%; */
		border: none;
		border-bottom: solid 1px #707070 !important;
		background: transparent !important;
		color: #303031;
		font-weight: 500;
	}

	.title-header {
		color: #0475f3;
		font-weight: 500;
		/* padding: 15px 5px 15px 25px; */
	}

	.label-title {
		/* padding-right: 75px;
		padding-top: 20px; */
		color: #0475f3;
		font-weight: 500;
	}

	.space_between {
		padding-left: 42px;
	}

	.target-label {
		color: rgb(4, 117, 243);
		font-weight: 500;
		padding-right: 53px;
		padding-bottom: 5px;
	}

	.team-target-table thead tr th {
		background: #00448b;
		color: #fff;
		padding: 2px 15px;
		font-size: 13px;
		font-weight: 400;
		text-align: center;
		/* white-space: nowrap; */
	}

	.team-target-table tbody tr td {
		background: #fff;
		padding: 4px 15px;
		font-size: 13px;
		font-weight: 400;
		border-bottom: 1px solid #f2f3f5;
		text-align: center;
		/* white-space: nowrap; */
	}

	.filter-btn {
		background-color: #00448b;
		width: 107px;
	}

	.search-box {
		border: 1px solid #669fd9;
		border-radius: 25px;
		color: rgba(103, 103, 103, 0.84);
		flex-grow: 1;
		margin-right: 2px;
		width: 180px;
	}

	.row-btn {
		justify-content: space-between;
		margin: 0px 15px 0px 45px;
	}

	.setTarget-btn .multiselect__tags {
		font-weight: 500;
		border: 0px !important;
	}

	.setTarget-btn {
		color: #00448b !important;
	}

	.setTarget-btn .multiselect__select:before {
		border-color: #00448b transparent transparent !important;
	}

	.setTarget-btn .multiselect__tags .multiselect__placeholder {
		color: #0475f3 !important;
	}

	.table-border{
		border: solid 1px #00448b;
		border-radius: 8px;
		padding: 0px 5px;
		margin-top: 5px;
	}

	.table-spacing {
		padding: 10px 15px;
	}

	.search-icon {
		border-radius: 20px 0px 0px 20px;
		padding: 8px 0px 8px 8px;
		height: 2.7em;
	}

	.search-text {
		border-radius: 0px 20px 20px 0px !important;
		padding-left: 0px;
		height: 2.9em;
	}

	.set-cancel {
		color: #005dae;
		border: 1px solid #005dae;
		background: #fff;
	}

	.set-save {
		color: #fff;
		background: #00448b;
		border: 1px solid #005dae;
	}

	.target-pagination {
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
	}

	.internal-btn {
		border: 1px solid grey;
		border-radius: 15px;
		background-color: #fff;
	}

	.dot {
		border: 1px solid #348bf5;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        padding-top: 2px;
        padding-bottom: 6px;
        padding-left:2px;
        background: #fff;
        color: #000;
        text-align: center;
        font-size: 14px;
        right: 20px;
    	top: 11px;
	}

	.icon-bg {
		background-color: #038b64;
		border-radius: 15px;
		color: #fff;
		font-size: 16px;
	}

	.plus-position {
		position: absolute;
		right: 110px;
		bottom: 25px;
	}

	.sales-filtersdata{
        height: 330px !important;
    	background: #e6ecff;
    	right: 54px;
    	top: 208px;
		overflow: initial !important;
    }

	.second-tableCol{
		border:solid 1px #005dae;
		border-radius: 8px;
		padding: 0px 0px;
		margin-top: 5px;
	}
	.pointer-events{
		pointer-events: none !important;
	}
	.btn-new-cancel {
        color: #005dae;
        background-color: #fff;
        border-radius: 5px;
        text-transform: none;
        font-weight: 500;
        border: 2px solid #005dae;
        line-height: 30px;
        box-shadow: none;
    }
    .btn-new-save {
        border: 2px solid #005dae;
        line-height: 30px;
        border-radius: 5px;
    }
	.dot-assign {
		border-radius: 50%;
        width: 25px;
        height: 25px;
        padding-top: 2px;
        padding-bottom: 6px;
        padding-left:2px;
        background: #fff;
        border: 0.5px solid #939393;
        color: #000;
        text-align: center;
        font-size: 14px;
        right: 13px;
    	top: 8px;
	}
	.viewdeal-filters{
        height: 230px !important;
		right: 75px;
		top: 242px;
		width: 350px;
    }
</style>


// WEBPACK FOOTER //
// src/components/SalesForeCast/CreateSetTarget.vue